import i18n from '@dms/i18n';
import {MileageInput} from '@dms/shared';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';

interface SimpleNumericFieldProps {
  name: 'mileage';
  vehicleId: string | null;
}

export function SimpleMilageField({name, vehicleId}: SimpleNumericFieldProps) {
  const {control, formApi} = useVehicleFormContext();

  return (
    <MileageInput
      control={control}
      formApi={formApi}
      name={name}
      label={i18n.t('entity.vehicle.labels.mileage')}
      vehicleId={vehicleId}
      data-testid="milage"
      shouldShowWarning
    />
  );
}
